module.exports = __webpack_public_path__ + "static/4-a76b9ad7701b869c739bc7db9bc63a28.jpg";